var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales-goods-box mt30"},[_c('div',{staticClass:"common-form"},[_vm._v("商品统计")]),_vm._v(" "),_c('div',{staticClass:"d-s-stretch bd-box"},[_c('div',{staticClass:"d-s-c d-c left-box"},[_c('Total'),_vm._v(" "),_c('LineChart')],1),_vm._v(" "),_c('Ranking')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5234619e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/sales/part/Goods.vue
// module id = null
// module chunks = 